/*!

 *

 *

 *  This file is auto generated by webpack.

 *  Do not edit this file directly.

 *

 *

 */

/******/ (function() { // webpackBootstrap

/******/  "use strict";

/******/  var __webpack_modules__ = ({

 

/***/ 326:

/***/ (function(__unused_webpack_module, exports) {

 

var __webpack_unused_export__;

 

__webpack_unused_export__ = ({ value: true });

class ShopifyFrontendHelper {

    constructor() {

        this.routes = '/';

        if (window.hasOwnProperty('Shopify')) {

            this.routes = window.Shopify.routes.root;

        }

    }

    fetchConfig(type = 'json') {

        return {

            method: 'POST',

            headers: { 'Content-Type': `application/${type}`, 'Accept': `application/${type}` }

        };

    }

    /* Will add items array to cart */

    async addToCart(items) {

        const body = JSON.stringify({ items: items });

        const config = this.fetchConfig();

        return await fetch(this.routes + 'cart/add.js', Object.assign(Object.assign({}, config), { body }))

            .then((response) => { return response.json(); })

            .then((state) => { return state; })

            .catch((e) => {

            return e;

        });

    }

    /* Will add variant of product to cart */

    async addVariantToCart(variantId, quantity, sellingPlan = null) {

        const items = [

            {

                id: variantId,

                quantity: quantity

            }

        ];

        if (sellingPlan) {

            items[0]["selling_plan"] = sellingPlan;

        }

        const body = JSON.stringify({ items: items });

        const config = this.fetchConfig();

        return await fetch(this.routes + 'cart/add.js', Object.assign(Object.assign({}, config), { body }))

            .then((response) => { return response.json(); })

            .then((state) => { return state; })

            .catch((e) => {

            return e;

        });

    }

    /* Will remove variant from cart */

    async removeFromCart(variantId) {

        let updates = {};

        updates[variantId] = 0;

        const body = JSON.stringify({ updates: updates });

        const config = this.fetchConfig();

        return await fetch(this.routes + 'cart/update.js', Object.assign(Object.assign({}, config), { body }))

            .then((response) => { return response.json(); })

            .then((state) => { return state; })

            .catch((e) => {

            return e;

        });

    }

    /* Will change quantity of variant in cart */

    async updateQuantityInCart(variantId, quantity, itemKey = null, updateSellingPlan = false, sellingPlan = null) {

        const updateBody = {

            id: itemKey ? itemKey : variantId,

            quantity: quantity,

        };

        if (updateSellingPlan) {

            updateBody["selling_plan"] = sellingPlan;

        }

        const body = JSON.stringify(updateBody);

        const config = this.fetchConfig();

        return await fetch(this.routes + 'cart/change.js', Object.assign(Object.assign({}, config), { body }))

            .then((response) => { return response.json(); })

            .then((state) => { return state; })

            .catch((e) => {

            return e;

        });

    }

    /* Will change quantity of variant in cart */

    async updateCartItem(updatedItem) {

        const body = JSON.stringify(updatedItem);

        const config = this.fetchConfig();

        return await fetch(this.routes + 'cart/change.js', Object.assign(Object.assign({}, config), { body }))

            .then((response) => { return response.json(); })

            .then((state) => { return state; })

            .catch((e) => {

            return e;

        });

    }

    /*

    Search function

    Type: product, page, article, collection

    Unavailable products:

        show: Show unavailable products.

        hide: Hide unavailable products.

        last: Show unavailable products below other matching results.

    Fields: author, body, product_type, tag, title, variants.barcode, variants.sku, variants.title, vendor

    More about parameters: https://shopify.dev/api/ajax/reference/predictive-search

    */

    async search(query, type = 'product', limit = 10, unavailable_products = 'last', fields = 'title,product_type,variants.title,vendor') {

        const url = this.routes

            + 'search/suggest.json?q='

            + query

            + '&resources[type]=' + type

            + '&resources[limit]=' + limit

            + '&resources[options][unavailable_products]=' + unavailable_products

            + '&resources[options][fields]=' + fields;

        return await fetch(url)

            .then((response) => response.json())

            .then((suggestions) => {

            return suggestions.resources.results;

        })

            .catch((e) => {

            return e;

        });

    }

    /* Will clear cart items */

    async clearCartItems() {

        const config = this.fetchConfig();

        return await fetch(this.routes + 'cart/clear.js', Object.assign({}, config))

            .then((response) => { return response.json(); })

            .then((state) => { return state; })

            .catch((e) => {

            return e;

        });

    }

    /* Will clear cart items with attributes and properties */

    async clearCartFully() {

        /* First clear attributes and note in cart */

        await fetch('/cart.js').then(result => result.json()).then(async (cart) => {

            for (const attr in cart.attributes) {

                cart.attributes[attr] = null;

            }

            cart.note = '';

            const body = JSON.stringify(cart);

            const config = this.fetchConfig();

            await fetch(this.routes + 'cart/update.js', Object.assign(Object.assign({}, config), { body }))

                .then((response) => { return response.json(); })

                .then((state) => { return state; })

                .catch((e) => {

                return e;

            });

        });

        /* Clear cart  items */

        return await this.clearCartItems();

    }

    /* Will log in customer. Recaptcha has to be disabled. If redirectUrl is empty we don't redirect after login */

    async customerLogin(email, password, redirectUrl = '/account/') {

        let formData = new FormData();

        formData.append('customer[email]', email);

        formData.append('customer[password]', password);

        formData.append('form_type', 'customer_login');

        formData.append('utf8', '✓');

        return await fetch("/account/login", {

            method: "POST",

            mode: "no-cors",

            cache: "no-cache",

            credentials: "same-origin",

            headers: {

                "Content-Type": "form-data"

            },

            body: formData

        })

            .then((response) => { return response.text(); })

            .then((html) => {

            if (!html.includes('/account/logout')) {

                return 'Wrong email or password';

            }

            else {

                if (redirectUrl != '') {

                    location.href = redirectUrl;

                }

                return 'Logged In';

            }

        })

            .catch((e) => {

            return e;

        });

    }

    /* Will log out customer */

    async customerLogout(redirectUrl = '/') {

        return await fetch(this.routes + 'account/logout')

            .then((response) => { })

            .then((state) => {

            if (redirectUrl != '') {

                location.href = redirectUrl;

            }

            return 'Logged Out';

        })

            .catch((e) => {

            return e;

        });

        // removed by dead control flow

 

    }

}

exports.A = ShopifyFrontendHelper;

//# sourceMappingURL=ShopifyFrontendHelper.js.map

 

/***/ })

 

/******/  });

/************************************************************************/

/******/  // The module cache

/******/  var __webpack_module_cache__ = {};

/******/  

/******/  // The require function

/******/  function __webpack_require__(moduleId) {

/******/    // Check if module is in cache

/******/    var cachedModule = __webpack_module_cache__[moduleId];

/******/    if (cachedModule !== undefined) {

/******/      return cachedModule.exports;

/******/    }

/******/    // Create a new module (and put it into the cache)

/******/    var module = __webpack_module_cache__[moduleId] = {

/******/      // no module.id needed

/******/      // no module.loaded needed

/******/      exports: {}

/******/    };

/******/  

/******/    // Execute the module function

/******/    __webpack_modules__[moduleId](module, module.exports, __webpack_require__);

/******/  

/******/    // Return the exports of the module

/******/    return module.exports;

/******/  }

/******/  

/************************************************************************/

var __webpack_exports__ = {};

 

// UNUSED EXPORTS: SerialNumberPicker

 

;// ./js/helpers/selectors.js

var SERIAL_NUMBER_PICKER_SELECTOR = '[data-serial-number-picker]';

;// ./js/helpers/utils.js

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var numericValueFromShopifyIdAsString = function numericValueFromShopifyIdAsString(shopifyId) {

  if (/^\d+$/.test(shopifyId)) {

    return shopifyId;

  }

  var regex = /gid:\/\/shopify\/\w+\/(\d+)/;

  var match = shopifyId.match(regex);

  var number = match ? match[1] : null;

  if (!number) {

    throw new Error();

  }

  return number;

};

var buildUrlWithHmac = function buildUrlWithHmac(url, queryParams, hmac) {

  var urlObj = new URL(url);

  urlObj.searchParams.forEach(function (value, key) {

    if (!Object.prototype.hasOwnProperty.call(queryParams, key)) {

      queryParams[key] = value;

    }

  });

  var allParams = _objectSpread(_objectSpread({}, queryParams), {}, {

    timestamp: hmac.timestamp,

    store: hmac.store,

    hmac: hmac.hmac

  });

  urlObj.search = new URLSearchParams(allParams).toString();

  return urlObj.toString();

};

// EXTERNAL MODULE: ./node_modules/shopify-api-js/lib/ShopifyFrontendHelper.js

var ShopifyFrontendHelper = __webpack_require__(326);

;// ./js/assets/serial-number-picker.js

function serial_number_picker_typeof(o) { "@babel/helpers - typeof"; return serial_number_picker_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, serial_number_picker_typeof(o); }

function _regenerator() { var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }

function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }

function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, serial_number_picker_toPropertyKey(o.key), o); } }

function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }

function serial_number_picker_toPropertyKey(t) { var i = serial_number_picker_toPrimitive(t, "string"); return "symbol" == serial_number_picker_typeof(i) ? i : i + ""; }

function serial_number_picker_toPrimitive(t, r) { if ("object" != serial_number_picker_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != serial_number_picker_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }




var SerialNumberPicker = function () {

  function SerialNumberPicker() {

    _classCallCheck(this, SerialNumberPicker);

    this.api = new ShopifyFrontendHelper/* default */.A();

    var root = this.api.routes;

    this.root = root.endsWith('/') ? root.slice(0, -1) : root;

    this.wrapper = document.querySelector(SERIAL_NUMBER_PICKER_SELECTOR);

    this.host = this.wrapper.dataset.backendUrl;

    this.customerId = this.wrapper.dataset.customerId;

    this.hmac = this.wrapper.dataset.hmac;

    this.form = this.wrapper.querySelector('form');

    this.input = this.form.querySelector('input#serial_number');

    this.feedback = this.form.querySelector('.form-message');

    this.submit = this.form.querySelector('button[type="submit"]');

    this.errorCodes = {

      PRODUCT_NOT_FOUND: 'PRODUCT_NOT_FOUND',

      VARIANT_NOT_FOUND: 'VARIANT_NOT_FOUND',

      CUSTOMER_NOT_FOUND: 'CUSTOMER_NOT_FOUND',

      COMPANY_NOT_FOUND: 'COMPANY_NOT_FOUND',

      INVALID_SERIAL_NUMBER: 'INVALID_SERIAL_NUMBER',

      ADD_TO_CART_ERROR: 'ADD_TO_CART_ERROR',

      ALREADY_IN_CART: 'ALREADY_IN_CART'

    };

    this.translations = {

      error: {

        PRODUCT_NOT_FOUND: this.wrapper.dataset.product_not_found,

        VARIANT_NOT_FOUND: this.wrapper.dataset.variant_not_found,

        CUSTOMER_NOT_FOUND: this.wrapper.dataset.customer_not_found,

        COMPANY_NOT_FOUND: this.wrapper.dataset.company_not_found,

        INVALID_SERIAL_NUMBER: this.wrapper.dataset.invalid_serial_number,

        ADD_TO_CART_ERROR: this.wrapper.dataset.add_to_cart_error,

        ALREADY_IN_CART: this.wrapper.dataset.already_in_cart,

        GENERAL: this.wrapper.dataset.general_error

      }

    };

  }

  return _createClass(SerialNumberPicker, [{

    key: "init",

    value: function init() {

      var _this = this;

      this.input.addEventListener('input', function () {

        _this.submit.disabled = _this.input.value.length < 3;

      });

      this.form.addEventListener('submit', function () {

        var _ref = _asyncToGenerator(_regenerator().m(function _callee(e) {

          var _product$variants, formData, data, serialNumber, product, variants, variant, variantId, alreadyAddedToCart, _t;

          return _regenerator().w(function (_context) {

            while (1) switch (_context.p = _context.n) {

              case 0:

                e.preventDefault();

                _this.wrapper.classList.add('processing');

                _this.feedback.classList.add('hidden');

                _context.p = 1;

                formData = new FormData(_this.form);

                data = Object.fromEntries(formData.entries());

                serialNumber = data.serial_number;

                if (serialNumber) {

                  _context.n = 2;

                  break;

                }

                return _context.a(2);

              case 2:

                _context.n = 3;

                return _this.fetchProduct(_this.host, serialNumber, _this.customerId);

              case 3:

                product = _context.v;

                if (product) {

                  _context.n = 4;

                  break;

                }

                throw new Error(_this.errorCodes.PRODUCT_NOT_FOUND);

              case 4:

                variants = (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants.edges;

                variant = variants && variants.length > 0 ? variants[0].node : null;

                if (variant) {

                  _context.n = 5;

                  break;

                }

                throw new Error(_this.errorCodes.VARIANT_NOT_FOUND);

              case 5:

                variantId = numericValueFromShopifyIdAsString(variant.id);

                _context.n = 6;

                return _this.isAlreadyInCart(variantId, serialNumber);

              case 6:

                alreadyAddedToCart = _context.v;

                if (!alreadyAddedToCart) {

                  _context.n = 7;

                  break;

                }

                throw new Error(_this.errorCodes.ALREADY_IN_CART);

              case 7:

                _context.n = 8;

                return _this.addProductToCart(variantId, serialNumber);

              case 8:

                _this.redirectToCart();

                _context.n = 10;

                break;

              case 9:

                _context.p = 9;

                _t = _context.v;

                _this.handleError(_t.message);

                console.error(_t);

              case 10:

                _context.p = 10;

                _this.wrapper.classList.remove('processing');

                console.log('in finally');

                return _context.f(10);

              case 11:

                return _context.a(2);

            }

          }, _callee, null, [[1, 9, 10, 11]]);

        }));

        return function (_x) {

          return _ref.apply(this, arguments);

        };

      }());

    }

  }, {

    key: "fetchProduct",

    value: function () {

      var _fetchProduct = _asyncToGenerator(_regenerator().m(function _callee2(host, serialNumber, customerId) {

        var url, response, data, _t2;

        return _regenerator().w(function (_context2) {

          while (1) switch (_context2.p = _context2.n) {

            case 0:

              _context2.p = 0;

              url = buildUrlWithHmac("".concat(host, "/products/search"), {

                serial: serialNumber,

                customerId: customerId

              }, JSON.parse(this.hmac));

              _context2.n = 1;

              return fetch(url);

            case 1:

              response = _context2.v;

              _context2.n = 2;

              return response.json();

            case 2:

              data = _context2.v;

              if (!(data.success !== true)) {

                _context2.n = 3;

                break;

              }

              throw new Error(data.message, {

                cause: data.description

              });

            case 3:

              return _context2.a(2, data.product);

            case 4:

              _context2.p = 4;

              _t2 = _context2.v;

              console.error("Error fetching product: ".concat(_t2.message));

              throw _t2;

            case 5:

              return _context2.a(2);

          }

        }, _callee2, this, [[0, 4]]);

      }));

      function fetchProduct(_x2, _x3, _x4) {

        return _fetchProduct.apply(this, arguments);

      }

      return fetchProduct;

    }()

  }, {

    key: "addProductToCart",

    value: function () {

      var _addProductToCart = _asyncToGenerator(_regenerator().m(function _callee3(variantId, serialNumber) {

        var cartAddResponse;

        return _regenerator().w(function (_context3) {

          while (1) switch (_context3.n) {

            case 0:

              _context3.n = 1;

              return this.api.addToCart([{

                id: parseInt(variantId, 10),

                quantity: 1,

                properties: {

                  serial_number: serialNumber

                }

              }]);

            case 1:

              cartAddResponse = _context3.v;

              if (!(cartAddResponse && !this.isCartStatusSuccess(cartAddResponse.status))) {

                _context3.n = 2;

                break;

              }

              console.error(cartAddResponse);

              throw new Error(this.errorCodes.ADD_TO_CART_ERROR);

            case 2:

              return _context3.a(2, cartAddResponse);

          }

        }, _callee3, this);

      }));

      function addProductToCart(_x5, _x6) {

        return _addProductToCart.apply(this, arguments);

      }

      return addProductToCart;

    }()

  }, {

    key: "isAlreadyInCart",

    value: function () {

      var _isAlreadyInCart = _asyncToGenerator(_regenerator().m(function _callee4(variantId, serialNumber) {

        var cart, alreadyAddedToCart;

        return _regenerator().w(function (_context4) {

          while (1) switch (_context4.n) {

            case 0:

              _context4.n = 1;

              return this.getCart();

            case 1:

              cart = _context4.v;

              alreadyAddedToCart = cart.items.find(function (item) {

                var _item$properties;

                return item.id === parseInt(variantId, 10) && ((_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : _item$properties.serial_number.toLowerCase()) === serialNumber.toLowerCase();

              });

              return _context4.a(2, Boolean(alreadyAddedToCart));

          }

        }, _callee4, this);

      }));

      function isAlreadyInCart(_x7, _x8) {

        return _isAlreadyInCart.apply(this, arguments);

      }

      return isAlreadyInCart;

    }()

  }, {

    key: "getCart",

    value: function () {

      var _getCart = _asyncToGenerator(_regenerator().m(function _callee5() {

        var url, cartResponse;

        return _regenerator().w(function (_context5) {

          while (1) switch (_context5.n) {

            case 0:

              url = "".concat(this.root, "/cart.js");

              _context5.n = 1;

              return fetch(url);

            case 1:

              cartResponse = _context5.v;

              _context5.n = 2;

              return cartResponse.json();

            case 2:

              return _context5.a(2, _context5.v);

          }

        }, _callee5, this);

      }));

      function getCart() {

        return _getCart.apply(this, arguments);

      }

      return getCart;

    }()

  }, {

    key: "redirectToCart",

    value: function redirectToCart() {

      window.location.href = "".concat(this.root, "/cart");

    }

  }, {

    key: "isCartStatusSuccess",

    value: function isCartStatusSuccess(status) {

      if (!status) {

        return true;

      }

      return status >= 200 && status < 300;

    }

  }, {

    key: "handleError",

    value: function handleError(message) {

      this.feedback.classList.remove('hidden');

      var knownCode = this.errorCodes[message];

      if (knownCode) {

        var _message = this.translations.error[knownCode];

        if (_message) {

          this.feedback.textContent = _message;

          return;

        }

      }

      this.feedback.textContent = this.translations.error.GENERAL;

    }

  }]);

}();

document.addEventListener('DOMContentLoaded', function (e) {

  new SerialNumberPicker().init();

});

/******/ })()

;